export default __webpack_public_path__ + "static/media/saude-mental.478376c4.png";